// @flow

import type { StaffGroupsState } from "./types";

export const initialState: StaffGroupsState = {
  error: null,
  list: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
      sort: { orders: [] },
    },
    totalElements: 0,
  },
};

export default initialState;
